var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCosignerCheckmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1662_48594",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1662_48594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.14961 9.2001L6.14961 8.21676C6.02739 8.09454 5.8885 8.03343 5.73294 8.03343C5.57739 8.03343 5.4385 8.09454 5.31628 8.21676C5.19405 8.33899 5.13294 8.48065 5.13294 8.64177C5.13294 8.80288 5.19405 8.94454 5.31628 9.06676L6.73294 10.4834C6.85517 10.6057 6.99405 10.6668 7.14961 10.6668C7.30516 10.6668 7.44405 10.6057 7.56628 10.4834L10.6829 7.36676C10.8052 7.24454 10.8663 7.10288 10.8663 6.94176C10.8663 6.78065 10.8052 6.63899 10.6829 6.51676C10.5607 6.39454 10.4218 6.33343 10.2663 6.33343C10.1107 6.33343 9.97183 6.39454 9.84961 6.51676L7.14961 9.2001ZM7.99961 14.9001C7.12183 14.9001 6.29405 14.7334 5.51628 14.4001C4.7385 14.0668 4.05794 13.6084 3.47461 13.0251C2.89128 12.4418 2.43294 11.7612 2.09961 10.9834C1.76628 10.2057 1.59961 9.37788 1.59961 8.5001C1.59961 7.61121 1.76628 6.78065 2.09961 6.00843C2.43294 5.23621 2.89128 4.55843 3.47461 3.9751C4.05794 3.39176 4.7385 2.93343 5.51628 2.6001C6.29405 2.26676 7.12183 2.1001 7.99961 2.1001C8.8885 2.1001 9.71905 2.26676 10.4913 2.6001C11.2635 2.93343 11.9413 3.39176 12.5246 3.9751C13.1079 4.55843 13.5663 5.23621 13.8996 6.00843C14.2329 6.78065 14.3996 7.61121 14.3996 8.5001C14.3996 9.37788 14.2329 10.2057 13.8996 10.9834C13.5663 11.7612 13.1079 12.4418 12.5246 13.0251C11.9413 13.6084 11.2635 14.0668 10.4913 14.4001C9.71905 14.7334 8.8885 14.9001 7.99961 14.9001ZM7.99961 13.7001C9.44405 13.7001 10.6718 13.1945 11.6829 12.1834C12.6941 11.1723 13.1996 9.94454 13.1996 8.5001C13.1996 7.05565 12.6941 5.82788 11.6829 4.81676C10.6718 3.80565 9.44405 3.3001 7.99961 3.3001C6.55516 3.3001 5.32739 3.80565 4.31628 4.81676C3.30517 5.82788 2.79961 7.05565 2.79961 8.5001C2.79961 9.94454 3.30517 11.1723 4.31628 12.1834C5.32739 13.1945 6.55516 13.7001 7.99961 13.7001Z",
    fill: "#2F4E26"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosignerCheckmark);
export default __webpack_public_path__ + "static/media/cosigner-checkmark.41d3f0579229dda8115af4b47ee52fc3.svg";
export { ForwardRef as ReactComponent };